import { Component, Input, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { DataService } from '../../utils/data.service';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { generalService } from '../../services/general.service';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { Router, ActivatedRoute } from '@angular/router';
import { Compania } from '../../models/compania';
import { ParametroSucursalComponent } from './parametros/parametros-sucursal.component';

@Component ({
  selector: 'my-sucursal-component',
  templateUrl: 'sucursal.component.html',
  styleUrls: ['./sucursal.component.scss'],
  providers: [generalService]
})

export class SucursalComponent {
  dataSucursales: DataSourceGrid | null;
  displayedColumns = ['acciones', 'nombre'];
  @Input() compania: Compania;

  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public isAdmin = this.userData.ADMIN;
  public datosGeneralesSAE: any;
  public idCompania: string;
  public listaSucursales: Array<any>;
  public formSucursal: FormGroup;
  public formTitulo: string = "Nueva Sucursal";
  public nombreSucursal: string;
  public idSucursal: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private _generalService: generalService, private formBuilder: FormBuilder,
              public dataService: DataService, private route: ActivatedRoute, 
              private router: Router, public dialog: MatDialog) {
    this.datosGeneralesSAE = DatosGeneralesSAE;
    this.datosGeneralesSAE.showSpinnerLoading = true;
    this.idCompania = this.route.snapshot.paramMap.get('id');
    this.compania = new Compania();
    this.listaSucursales = new Array();
  }

  ngOnInit() {
    this.getCompania();
    this.getSucursales();
    this.buildFormulario();
    this.editSucursal(false, null);
  }

  back() {
    this.router.navigate(['../../compania'],{ relativeTo: this.route });  }

  getCompania(){
    this._generalService.metodoCall(`compania/consultarCompania/${this.idCompania}`)
      .subscribe(result => {
        let res = JSON.parse(result);
        this.compania = res[0];   });
  }

  getSucursales(){
      let link = "Sucursal/consultaSucursales/" + this.idCompania; 

      this._generalService.metodoCall(link).subscribe(
        result => {
          this.listaSucursales = JSON.parse(result);
          this.dataSucursales = new DataSourceGrid(this.listaSucursales, this.paginator, this.sort);
          if(this.listaSucursales.length <= 0)
            { $(".mat-row").remove(".mat-row"); }
            this.datosGeneralesSAE.showSpinnerLoading = false;
          },
        error => {  console.log(<any>error);  }
      );
  }

  buildFormulario() {
    this.formSucursal = this.formBuilder.group({
      nombre: this.formBuilder.control(null, [Validators.required]) });
  }

  editSucursal(editar, registro) {
    if (editar) {
      this.formTitulo = "Actualizar Sucursal";
      this.nombreSucursal = registro.nombreSucursal;
      this.idSucursal = registro.idSucursal;

      this.formSucursal.controls['nombre'].setValue(this.nombreSucursal);
    }
  }

  addSucursal(){
    this.datosGeneralesSAE.showSpinnerLoading = true;
    let tipo = 'editar';
    let metodo = 'Sucursal/insertarSucursal/' + this.idCompania;

    if (this.idSucursal != null) {
      metodo = 'Sucursal/actualizarSucursal/' + this.idSucursal;
    }

    this._generalService.metodoCallParamsPutPost(tipo, this.nombreSucursal, metodo).subscribe(
      (result) => { 
        if (result != '') 
          { this._generalService.toastCall(result);  }
        this.getSucursales();
        this.formSucursal.reset();
        this.nombreSucursal = null;
        this.idSucursal = null;
        this.formTitulo = "Nueva Sucursal";   },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
        this._generalService.toastCall(errorMsj);   }
    ); 
  }

  deleteSucursal(registro) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.getSucursales(); });

    this._generalService.modal(eliminarHttp, 'confirm',
                               `¿Desea cambiar el estado de la sucursal ${registro.nombreSucursal} a inactiva?`,
                               'Sucursal/eliminarSucursal', registro.idSucursal);
  }

  gotoParametros(registro) {
    this.dataService.id = registro.idSucursal;
    this.dataService.isUpdate = registro.activo;
    this.dataService.mensaje = registro.nombreSucursal;
    const dialogRef = this.dialog.open(ParametroSucursalComponent, 
    { disableClose: true, width:'100%', maxWidth:'60%', 
      panelClass: 'full-width-dialog' });
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      this.dataService.id = null;
      this.dataService.isUpdate = null;
      this.dataService.mensaje = null;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.getSucursales();     
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/compania/sucursales/sucursal.component.ts